"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
exports.__esModule = true;
exports.updateEntity = void 0;
/**
 * Update given entity with the data, potentially evolving
 * it based on the existing values.
 */
function updateEntity(entity, data) {
    return Object.entries(data).reduce(function (acc, _a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        // Ignore attempts to update entity with properties
        // that were not specified in the model definition.
        if (!entity.hasOwnProperty(key)) {
            return acc;
        }
        acc[key] =
            typeof value === 'function' ? value(entity[key], entity) : value;
        return acc;
    }, __assign({}, entity));
}
exports.updateEntity = updateEntity;
